import { degreesToRadians, transformTo0360 } from './utils';
import { Clock } from 'three';

// const roomsGlb = {
//   Black: blackRoom,
//   White: whiteRoom,
//   Gold: goldRoom,
// };

export const rouletteDiskState = {
  angle: 0,
  angleSpeed: 1.2,
  rotationDirection: 1,
  frameCount: 0,
  fps: 0,
  clock: new Clock(),
  getAngle: () => rouletteDiskState.angle - 90,
  getAngleRadian: () => degreesToRadians(rouletteDiskState.angle) - Math.PI / 2,
  addAngle: (addingAngle) => rouletteDiskState.angle = transformTo0360(rouletteDiskState.angle + (rouletteDiskState.rotationDirection * addingAngle)),
};

// export const addRouletteGLBModel = (scene, roomName) => {
//   if (sceneObjects.get(SCENE_OBJ_NAMES.rouletteRoom)) {
//     scene.remove(sceneObjects.get(SCENE_OBJ_NAMES.rouletteRoom));
//   }
//
//   //.visible = false;
//   console.log(roomName);
//
//   scene.add(roomsManagementHub.roomsGlb[roomName]);
//
//   // loader.load(roomsGlb[roomName], (gltf) => {
//   //   const model = gltf.scene;
//   //   scene.add(model);
//   //   sceneObjects.set(SCENE_OBJ_NAMES.rouletteRoom, model);
//   //
//   //   model.traverse((child) => {
//   //     if (child.name === 'table_1' || child.name === 'table_002') {
//   //       sceneObjects.set(SCENE_OBJ_NAMES.rouletteDisk, child);
//   //     }
//   //   });
//   //
//   //   loadedState.roomGlb = true;
//   //   loadingStore.setThreeJsIsLoad(loadedState.hdr && loadedState.roomGlb);
//   // });
// };

// export const rotateRouletteDisk = () => {
//   requestAnimationFrame(rotateRouletteDisk);
//   try {
//     const rouletteDiskMesh = sceneObjects.get(SCENE_OBJ_NAMES.rouletteDisk);
//     rouletteDiskMesh.rotation.y = rouletteDiskState.getAngleRadian();
//     rouletteDiskState.frameCount++;
//     const delta = rouletteDiskState.clock.getDelta();
//     rouletteDiskState.fps = Math.round(rouletteDiskState.frameCount / delta);
//     const addingAngle = rouletteDiskState.angleSpeed * (STANDARD_FPS / rouletteDiskState.fps);
//     if (isFinite(addingAngle)) {
//       rouletteDiskState.addAngle(addingAngle);
//     }
//     rouletteDiskState.frameCount = 0;
//     rouletteDiskState.clock.start();
//   } catch (err) {
//
//   }
// };

// export const startRouletteDiskRotation = () => rotateRouletteDisk();

// startRouletteDiskRotation();
